<template>
    <form>
        <h3>Section Three - Pacific Ancestry</h3>
        <h4>Which ethnic groups do you belong to?</h4>
        <div class="cb-box">
            <t2-checkbox other="Villages" v-model:otherValue="$parent.rec.SamoanVillages" v-model="$parent.rec.Samoan" label="Samoan" />
            <t2-checkbox other="Villages" v-model:otherValue="$parent.rec.NiueanVillages" v-model="$parent.rec.Niuean" label="Niuean" />
            <t2-checkbox other="Villages" v-model:otherValue="$parent.rec.TonganVillages" v-model="$parent.rec.Tongan" label="Tongan" />
            <t2-checkbox other="Villages" v-model:otherValue="$parent.rec.CookIslandVillages" v-model="$parent.rec.CookIsland" label="Cook Island" />
            <t2-checkbox other="Villages" v-model:otherValue="$parent.rec.iTaukeiFijianVillages" v-model="$parent.rec.iTaukeiFijian" label="i-Taukei Fijian" />
            <t2-checkbox other="Villages" v-model:otherValue="$parent.rec.RotumanVillages" v-model="$parent.rec.Rotuman" label="Rotuman" />
            <t2-checkbox other="Villages" v-model:otherValue="$parent.rec.TuvaluanVillages" v-model="$parent.rec.Tuvaluan" label="Tuvaluan" />
            <t2-checkbox other="Villages" v-model:otherValue="$parent.rec.TokelauanVillages" v-model="$parent.rec.Tokelauan" label="Tokelauan" />
            <t2-checkbox other="Villages" v-model:otherValue="$parent.rec.KiribatiVillages" v-model="$parent.rec.Kiribati" label="Kiribati" />
            <t2-checkbox other="Specify + villages" v-model:otherValue="$parent.rec.OtherPacificethnicityVillages" v-model="$parent.rec.OtherPacificethnicity" label="Other Pacific ethnicity" />
            <t2-checkbox v-model="$parent.rec.Māori" label="Māori" />
            <t2-checkbox v-model="$parent.rec.NZEuropean" label="NZ European" />
            <t2-checkbox v-model="$parent.rec.Chinese" label="Chinese" />
            <t2-checkbox v-model="$parent.rec.Indian" label="Indian" />
            <t2-checkbox v-model="$parent.rec.MELAA" label="MELAA" />
            <t2-checkbox other="Specify" v-model:otherValue="$parent.rec.EthnicityOtherSpecify" v-model="$parent.rec.EthnicityOther" label="Other" />
        </div>
        <footer><button @click.prevent="$parent.prevTab">Back</button><button @click.prevent="$parent.nextTab">Next</button></footer>
    </form>
</template>

<script>
import t2Checkbox from '@/components/t2-checkbox.vue'
export default {
    name:"section 3",
    components:{t2Checkbox},
    data: function (){return {
    }},
    methods:{
        allGood: function (){

        let checked=["Samoan","Niuean","Tongan","CookIsland","iTaukeiFijian","Rotuman","Tuvaluan","Tokelauan",
            "Kiribati","OtherPacificethnicity","Māori","NZEuropean","Chinese","Indian","MELAA","EthnicityOther"].filter(u=>this.$parent.rec[u]);
        return checked.length>0
        }
    }
}
</script>

<style>
</style>